import { render, staticRenderFns } from "./SectorEdit.vue?vue&type=template&id=33872069&"
import script from "./SectorEdit.vue?vue&type=script&lang=js&"
export * from "./SectorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports